import { useIsSearchToFeedEnabled } from '@modules/common/hooks';
import { Alert } from '@mui/material';

export const OutboundCardRealtimeAlert = () => {
  const isSearchToFeedEnabled = useIsSearchToFeedEnabled();

  return (
    <Alert severity="info" sx={{ mt: 2 }}>
      Enterpret will send a report when there is new feedback available for this{' '}
      {isSearchToFeedEnabled ? 'Feed' : 'Saved Search'}.
    </Alert>
  );
};
